import {Component, Input} from "@angular/core";

@Component({
    selector: 'app-button-submit',
    template: `
    <button class="btn btn-outline-primary" type="submit" [disabled]="invalid">{{label | i18next}}</button>
  `,
    styleUrls: [],
    standalone: false
})
export class ButtonSubmit {
  @Input() invalid: boolean;
  @Input() label: string = 'app_update';
}